import { BasicEnumerable } from "../BasicEnumerable.js";
export const take = (source, amount) => {
    function* iterator() {
        let amountLeft = amount > 0 ? amount : 0;
        for (const item of source) {
            if (amountLeft-- === 0) {
                break;
            }
            else {
                yield item;
            }
        }
    }
    return new BasicEnumerable(iterator);
};
